import { STATIC_BASE_URL } from 'config';

export const useDefaultImg = (e) => {
  if (e.target && (e.target as any).tagName === 'IMG') {
    (e.target as any).src = STATIC_BASE_URL + '/images/icon-img.svg';
  }
};
